import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;
const red = ui.red[500];

export const errorContainerCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  padding: "1rem",
  margin: "auto",
};

export const errorMessageCss: CSSObject = {
  textAlign: "center",
};

export const errorMessageIconCss = (color: string) => ({
  paddingBottom: "1rem",
  path: {
    fill: red,
    stroke: color,
  },
});
